









import $ from 'jquery';
import Collection from 'ol/Collection';
import { defaults as defaultControls, MousePosition } from 'ol/control';
import { Coordinate, createStringXY } from 'ol/coordinate';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Modify } from 'ol/interaction';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import Map from 'ol/Map';
import { fromLonLat } from 'ol/proj';
import { OSM, Vector as VectorSource } from 'ol/source';
import { Style, Icon } from 'ol/style';
import View from 'ol/View';
import { Component, Vue, Prop } from 'vue-property-decorator';

const locationIcon = require('../assets/img/pin.png');

export type AddressData = {
  addressInfo: {
    postalCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
  };
  geocodeInfo: {
    latitude: number;
    longitude: number;
    zipcode: string;
    city: string;
    state: string;
    streetName: string;
  };
};

@Component
export default class LocationMapComponent extends Vue {
  @Prop({ required: true })
  private latLon!: { latitude: number; longitude: number };

  private map!: Map;

  private positionMarker!: Feature;

  private zoom = 15;

  mounted() {
    this.renderMap([this.latLon?.longitude, this.latLon?.latitude]);
  }

  isValidCoordinate(coordinate: Coordinate) {
    const [longitude, latitude] = coordinate || [];
    const isValid = longitude !== null && !Number.isNaN(longitude) && latitude !== null && !Number.isNaN(latitude);

    return isValid;
  }

  public renderMap(coordinate: Coordinate) {
    if (!this.isValidCoordinate(coordinate)) {
      return;
    }

    $('#map').empty();
    $('#mouse-position').empty();
    const zoom = this.map?.getView()?.getZoom() || this.zoom;

    this.map = new Map({
      controls: defaultControls().extend([
        new MousePosition({
          coordinateFormat: createStringXY(4),
          projection: 'EPSG:4326',
          // comment the following two lines to have the mouse position
          // be placed within the map.
          className: 'custom-mouse-position',
          target: document.getElementById('mouse-position'),
          undefinedHTML: '&nbsp;',
        }),
      ]),
      target: 'map',
    });
    const coordinates = fromLonLat(coordinate);

    this.map.addLayer(
      new TileLayer({
        source: new OSM(),
      }),
    );
    const source = new VectorSource();
    const markerLayer = new VectorLayer({
      source,
    });

    this.positionMarker = this.createMarker(coordinates);
    source.addFeature(this.positionMarker);
    const modifyInterection = this.makeMarkerMovable(this.positionMarker);

    this.map.addLayer(markerLayer);
    this.map.addInteraction(modifyInterection);
    this.map.setView(
      new View({
        center: coordinates,
        zoom,
      }),
    );
  }

  private makeMarkerMovable(feature: Feature) {
    const modify = new Modify({
      features: new Collection([feature]),
    });

    return modify;
  }

  private createMarker(coordinates: number[]): Feature {
    const feature = new Feature();

    feature.setStyle(
      new Style({
        image: new Icon({
          src: locationIcon,
          scale: 0.6,
        }),
      }),
    );
    feature.setGeometry(new Point(coordinates));

    return feature;
  }

  private extractCoordinates(text: string): Coordinate {
    return [Number(Number(text.split(', ')[0]).toFixed(7)), Number(Number(text.split(', ')[1]).toFixed(7))];
  }
}
